import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRewardRoute } from '@/common/reward/route.registry';
import { InjectionFeature } from '@/common/reward/types';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router, { ROUTE_NAME_ARENA } from './router';

export default registerRouteForModule(router);

registerRewardRoute(InjectionFeature.ArenaTicket, {
    routeToIndexPage: () => ({ name: ROUTE_NAME_ARENA.TICKET.INDEX }),
    routeToInfoPage: type => ({ name: ROUTE_NAME_ARENA.TICKET.EDIT, params: { type } })
});

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Arena',
        name: 'Arena',
        icon: 'fas fa-flag-checkered',
        roles: [Role.ADMIN]
    },
    {
        parent: 'Multiplayer.Arena',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_ARENA.ITEM.INDEX }
    },
    {
        parent: 'Multiplayer.Arena',
        key: 'Cycle',
        name: 'Cycle',
        icon: 'fas fa-sync-alt',
        route: { name: ROUTE_NAME_ARENA.CYCLE.INDEX }
    },
    {
        parent: 'Multiplayer.Arena',
        key: 'Medal',
        name: 'Medal',
        icon: 'fas fa-medal',
        route: { name: ROUTE_NAME_ARENA.MEDAL.INDEX }
    },
    {
        parent: 'Multiplayer.Arena',
        key: 'Ticket',
        name: 'Ticket',
        icon: 'fas fa-ticket-alt',
        route: { name: ROUTE_NAME_ARENA.TICKET.INDEX }
    }
]);
